import React from 'react';
import ReactDOM from 'react-dom';
import OperatorForm from './components/Onboarding Forms/OperatorOnboarding';
import * as serviceWorker from './serviceWorker';

const googleMapScript = document.createElement('script');
googleMapScript.src =
  process.env.REACT_APP_GOOGLE_MAP_SOURCE ||
  `https://maps.googleapis.com/maps/api/js?key=AIzaSyBTkv7gCyx184hQhbKb41UCqQ6KWOnnc9s&libraries=places`;
googleMapScript.async = true;
window.document.body.appendChild(googleMapScript);

ReactDOM.render(<OperatorForm />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
